<template>

  <div>
    <el-dialog title="签到人员" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
      <div class="check-in-container">
        <!-- <div class="header-actions">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addCheckIn">添加签到</el-button>
        </div> -->

        <el-table size="small" :data="checkInList" border style="width: 100%" v-loading="loading">
          <el-table-column label="注册照图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.yg_image"
                style="width: 50px; height: 50px"
                :src="scope.row.yg_image"
                :preview-src-list="[scope.row.yg_image]"
                fit="cover"
              />
              <span v-else class="text-placeholder">—</span>
            </template>
          </el-table-column>
          <el-table-column prop="employee_name" label="员工姓名" width="120"></el-table-column>
          <el-table-column label="会议签名图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.signature"
                style="width: 50px; height: 50px"
                :src="scope.row.signature"
                :preview-src-list="[scope.row.signature]"
                fit="cover"
              />
              <span v-else class="text-placeholder">—</span>
            </template>
          </el-table-column>
          <el-table-column prop="meeting_name" label="会议名称" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="check_in_time" label="进入时间" width="160"></el-table-column>
          <el-table-column prop="check_out_time" label="退出时间" width="160"></el-table-column>
          <el-table-column label="现场照图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.check_in_image"
                style="width: 50px; height: 50px"
                :src="scope.row.check_in_image"
                :preview-src-list="[scope.row.check_in_image]"
                fit="cover"
              />
              <span v-else class="text-placeholder">—</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="deleteCheckIn(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="添加签到" :visible.sync="addDialogVisible" width="40%" @close="closeAddDialog">
      <el-form :model="checkInForm" label-width="100px" size="small" ref="checkInForm">
        <el-form-item label="员工姓名" prop="employee_id">
          <el-select v-model="checkInForm.employee_id" placeholder="请选择员工" filterable>
            <el-option v-for="item in employeeList" :key="item.ma_employee_id" :label="item.name" :value="item.ma_employee_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="checkInForm.employee_phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="checkInForm.remark" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';

export default {
  props: ['open_check_in', 'ma_new_meeting_id'],
  data() {
    return {
      dialogVisible: false,
      addDialogVisible: false,
      loading: false,
      checkInList: [],
      employeeList: [],
      checkInForm: {
        employee_id: '',
        employee_phone: '',
        remark: ''
      }
    };
  },
  watch: {
    open_check_in: {
      handler(val) {
        if (val) {
          this.dialogVisible = true;
          this.loadCheckInList();
          this.loadEmployeeList();
        } else {
          this.dialogVisible = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    loadCheckInList() {
      let self = this;
      self.loading = true;
      Ma_new_meetingApi.getCheckInList({ ma_new_meeting_id: self.ma_new_meeting_id }, true)
          .then(data => {
            self.loading = false;
            if (data.code === 1) {
              const list = data.data.list;
              // 兼容 list 为分页对象 { data: [], total, ... } 或直接为数组
              const rawList = (list && list.data) ? list.data : (list || []);
              // 按接口返回格式映射为表格展示字段
              self.checkInList = rawList.map(item => ({
                ...item,
                yg_image: item.yg_image != null ? item.yg_image : (item.avatar != null ? item.avatar : ''),
                employee_name: item.employee_name != null ? item.employee_name : (item.name != null ? item.name : ''),
                signature: item.signature != null ? item.signature : '',
                meeting_name: item.meeting_name != null ? item.meeting_name : (item.meeting_title != null ? item.meeting_title : ''),
                check_in_time: item.check_in_time != null ? item.check_in_time : (item.sign_in_time != null ? item.sign_in_time : ''),
                check_out_time: item.check_out_time != null ? item.check_out_time : (item.sign_out_time != null ? item.sign_out_time : ''),
                check_in_image: item.check_in_image != null ? item.check_in_image : (item.scene_image != null ? item.scene_image : '')
              }));
            }
          })
          .catch(error => {
            self.loading = false;
          });
    },

    loadEmployeeList() {
      let self = this;
      Ma_new_meetingApi.getEmployeeList({}, true)
          .then(data => {
            if (data.code === 1) {
              self.employeeList = data.data.list || [];
            }
          })
          .catch(error => {
          });
    },

    addCheckIn() {
      this.checkInForm = {
        employee_id: '',
        employee_phone: '',
        remark: ''
      };
      this.addDialogVisible = true;
    },

    submitAdd() {
      let self = this;
      if (!self.checkInForm.employee_id) {
        self.$message.warning('请选择员工');
        return;
      }

      let params = {
        ma_new_meeting_id: self.ma_new_meeting_id,
        ...self.checkInForm
      };

      self.loading = true;
      Ma_new_meetingApi.addCheckIn(params, true)
          .then(data => {
            self.loading = false;
            if (data.code === 1) {
              self.$message.success('签到成功');
              self.addDialogVisible = false;
              self.loadCheckInList();
            } else {
              self.$message.error(data.msg || '签到失败');
            }
          })
          .catch(error => {
            self.loading = false;
          });
    },

    deleteCheckIn(row) {
      let self = this;
      self
          .$confirm('确定要删除这条签到记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_new_meetingApi.deleteCheckIn({ id: row.id }, true)
                .then(data => {
                  if (data.code === 1) {
                    self.$message.success('删除成功');
                    self.loadCheckInList();
                  } else {
                    self.$message.error('删除失败');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    },

    closeDialog() {
      this.$emit('close');
    },

    closeAddDialog() {
      this.addDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.check-in-container {
  padding: 20px;
}

.header-actions {
  margin-bottom: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

.text-placeholder {
  color: #c0c4cc;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/part/CheckInPerson.vue